import { Link } from 'react-router-dom';

import { useSession } from 'src/features/auth/useAuth';
import Avatar from 'src/shared/components/ui/Avatar';
import Wordmark from 'src/shared/components/ui/Wordmark';

interface TopBarProps {
  onOpenAccount: () => void;
}

/** The phone's header: the brand, and the account behind the avatar. */
export default function TopBar({ onOpenAccount }: TopBarProps) {
  const user = useSession();

  return (
    <header className="v-topbar">
      <Link to="/" className="text-decoration-none" aria-label="Grazia, ir al inicio">
        <Wordmark />
      </Link>
      {user && (
        <button
          type="button"
          className="btn v-ghost v-icon-btn rounded-circle"
          onClick={onOpenAccount}
          aria-label="Tu cuenta"
        >
          <Avatar name={user.fullName || user.email} size={36} variant="ink" />
        </button>
      )}
    </header>
  );
}
